import { Offer } from "@/types/offer";
import { ecsClient, getGlobalSessionId } from "./index";

type OfferResponse = {
  offers: Offer[];
  supportPortalUrl: string;
};

const OfferServices = {
  getOffers: async (params?: any): Promise<OfferResponse> => {
    try {
      const sessionId = getGlobalSessionId();
      const response = await ecsClient.get<OfferResponse>("/offers", {
        params: { sessionId, ...params },
      });

      return response.data || { offers: [], supportPortalUrl: "" };
    } catch (error: any) {
      console.error("Get offers error:", {
        error: error,
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      return {
        offers: [],
        supportPortalUrl: "",
      };
    }
  },
};

export default OfferServices;
